import PrivateImage from '../presentation/PrivateImage';
import React, {useEffect, useRef, useState} from "react";
import {Redirect, useParams} from "react-router-dom";
import UserService from "../../services/user.service";
import '../../Print.css';
import { logOut} from "../../helpers/logout";
import {Button, Divider, Grid, Toolbar} from "@material-ui/core";
import ActionButton from "../form/input/ActionButton";
import Tooltip from "@material-ui/core/Tooltip";
import Paper from "@material-ui/core/Paper";
import Container from "@material-ui/core/Container";
import {makeStyles} from "@material-ui/core/styles";
import clsx from "clsx";
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import GeneratedDocumentEmailAction from "./GeneratedDocumentEmailAction";
import {PDFExport} from '@progress/kendo-react-pdf';
import {getPdfExportProxyProps, savePdfWithEmbeddedImages} from "../../helpers/pdfExport";
import {NotificationManager} from "react-notifications";


const useStyles = makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    seeMore: {
        marginTop: theme.spacing(8),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    toolbarButtons: {
        '& .MuiFormControl-root': {
            margin: theme.spacing(1)
        }
    },
    marginElement: {
        margin: theme.spacing(2)
    },
    marginTop: {
        marginTop: theme.spacing(2)
    },
    icon: {
        marginRight: theme.spacing(2),
    },
    heroContent: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(8, 0, 6),
    },
    heroButtons: {
        marginTop: theme.spacing(4),
    },
    cardGrid: {
        paddingTop: theme.spacing(8),
        paddingBottom: theme.spacing(8),
    },
    cardMedia: {
        height: 200,
        width: 150,
        borderRadius: 10
    },
    cardContent: {
        flexGrow: 1,
    },
}));


const InformationPaperGenerator = (props) => {
    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper);

    const pdfRef = useRef(null);
    const [funeral, setFuneral] = useState({
        contracting_authority: '',
        ca_address: '',
        ca_zip: '',
        ca_city: '',
        ca_state: '',
        ca_nationality: '',
        ca_email: '',
        ca_phone: '',
        ca_id: '',
        ca_birth: '',
        ca_relationship: '',
        deceased: '',
        d_address: '',
        d_zip: '',
        d_city: '',
        d_state: '',
        d_place_birth: '',
        d_birth: '',
        d_gender: '',
        d_marital_status: '',
        d_death: '',
        d_place_death: '',
        d_id: '',
        d_nationality: '',
        d_education: '',
        d_last_job: '',
        d_wife_husband: '',
        d_wife_husband_id: '',
        planned_pickup_place: '',
        planned_pickup: '',
        town_funeral: '',
        place_funeral: '',
        date_funeral: '',
        coffin_arrival: '',
        coffin_arrival_place: '',
        signatures: {},
        product_entities: [],
        service_entities: []
    });
    const [success, setSuccess] = useState(false);

    const [user, setUser] = useState(null);

    const funeral_id = useParams();
    const user_local = JSON.parse(localStorage.getItem('user')).id;

    useEffect(() => {
        UserService.getUser(user_local).then(
            (response) => {
                setUser(response.data);
            },
            (e) => {
                if (e.response.status === 401) {
                    logOut(props);
                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                }
            }
        );
        UserService.getFuneral(funeral_id.funeral_id).then(
            (response) => {
                setFuneral(response.data);
            },
            (e) => {
                if (e.response.status === 401) {
                    logOut(props);
                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                }
            }
        );
    }, [funeral_id.funeral_id, user_local, props]);

    const handleExport = () => {
        savePdfWithEmbeddedImages(pdfRef);
    }

    const listItems = (entities) => {
        return funeral[entities].map((item, index) => {
            if (item.show_list) {
                if (item.text) {
                    return <li key={index}><span>{item.name}</span><span className="gendoc-list__meta">{item.text}</span></li>
                }
                if (item.number) {
                    return <li key={index}><span>{item.name}</span><span className="gendoc-list__meta">{item.number}</span></li>
                }
                if (item.yes_no !== undefined) {
                    return <li key={index}><span>{item.name}</span><span className="gendoc-list__meta">{item.yes_no ? 'Áno' : 'Nie'}</span></li>
                }
                if (item.text_cost) {
                    return <li key={index}><span>{item.name}</span><span className="gendoc-list__meta">{item.text_cost.text}</span></li>
                }
            }
            return ''
        })
    }

    const showDelegation = () => {
        if (user) {
            return <div className="document-preview-frame" style={{border: '1px solid'}}>
                <PDFExport ref={pdfRef} {...getPdfExportProxyProps()} paperSize="A4" scale={0.75}
                           fileName={`informacnylist-${funeral.deceased.replace(' ', '')}`}>
                    <div className="a4-paper gendoc-doc">
                        {user.logo &&
                        <div className="gendoc-watermark-wrap">
                            <PrivateImage className="gendoc-watermark" src={user.logo} alt=""/>
                        </div>}
                        <div className="gendoc-body">
                            <header className="gendoc-header">
                                <div className="gendoc-header__eyebrow">{user.name}</div>
                                <h1 className="gendoc-title">Informačný list k pohrebu</h1>
                                <div className="gendoc-header__meta">
                                    {user.address} · IČO: {user.ico} · IČ DPH: {user.ic_dph} · Kontakt: {user.phone} · Email: {user.email_official}
                                </div>
                            </header>

                            <section className="gendoc-section">
                                <h2 className="gendoc-section-title">Prehľad</h2>
                                <div className="gendoc-fields">
                                    <div className="gendoc-field">
                                        <span className="gendoc-label">Zosnulý/á</span>
                                        <span className="gendoc-value">{funeral.deceased}</span>
                                    </div>
                                    <div className="gendoc-field">
                                        <span className="gendoc-label">Kedy bude pohreb</span>
                                        <span className="gendoc-value">{funeral.date_funeral && new Date(funeral.date_funeral).toShortFormatWithTimeExcel()}</span>
                                    </div>
                                    <div className="gendoc-field">
                                        <span className="gendoc-label">Dátum narodenia</span>
                                        <span className="gendoc-value">{funeral.d_birth && new Date(funeral.d_birth).toShortFormat()}</span>
                                    </div>
                                    <div className="gendoc-field">
                                        <span className="gendoc-label">Mesto/Obec pohrebu</span>
                                        <span className="gendoc-value">{funeral.town_funeral}</span>
                                    </div>
                                    <div className="gendoc-field">
                                        <span className="gendoc-label">Dátum úmrtia</span>
                                        <span className="gendoc-value">{funeral.d_death && new Date(funeral.d_death).toShortFormat()}</span>
                                    </div>
                                    <div className="gendoc-field">
                                        <span className="gendoc-label">Miesto pohrebu</span>
                                        <span className="gendoc-value">{funeral.place_funeral}</span>
                                    </div>
                                </div>
                            </section>

                            <section className="gendoc-section">
                                <h2 className="gendoc-section-title">Objednané produkty</h2>
                                <ul className="gendoc-list">
                                    {listItems('product_entities')}
                                </ul>
                            </section>

                            <section className="gendoc-section">
                                <h2 className="gendoc-section-title">Objednané služby</h2>
                                <ul className="gendoc-list">
                                    {listItems('service_entities')}
                                </ul>
                            </section>

                            {user.defined_texts && user.defined_texts.important_contacts ?
                                <section className="gendoc-section">
                                    <h2 className="gendoc-section-title">Užitočné kontakty</h2>
                                    <div className="gendoc-legal">{user.defined_texts.important_contacts}</div>
                                </section>
                                : ''}

                            {user.defined_texts && user.defined_texts.what_next ?
                                <section className="gendoc-section">
                                    <h2 className="gendoc-section-title">Dalšie kroky</h2>
                                    <div className="gendoc-legal">{user.defined_texts.what_next}</div>
                                </section>
                                : ''}

                            <div className="gendoc-legal gendoc-legal--fine">
                                V prípade akýchkoľvek otázok nás neváhajte kontaktovať. Tento dokument slúži len na
                                informačné účely. {user.email_official}, {user.phone}
                            </div>
                        </div>
                    </div>
                </PDFExport>
            </div>
        }
        return <></>
    }

    return (
        <Container maxWidth="lg" className={classes.seeMore}>
            <div className={classes.root}>
                <Paper className={fixedHeightPaper}>
                    <Grid container>
                        <Grid xs={12} sm={4} md={3} lg={3} item container>
                            <Toolbar>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    hidden={true}
                                    className={classes.button}
                                    onClick={() => {
                                        setSuccess(true)
                                    }}
                                >
                                    Späť na detaily
                                </Button>
                            </Toolbar>
                        </Grid>
                        <Grid xs={12} sm={8} md={9} lg={9} item container justifyContent='flex-end'>
                            <Toolbar className={`${classes.toolbarButtons} document-actions-toolbar`}>
                                <ActionButton
                                    color="primary">
                                    <Tooltip title="Pdf export">
                                        <PictureAsPdfIcon
                                            fontSize="small"
                                            onClick={handleExport}
                                        />
                                    </Tooltip>
                                </ActionButton>
                                <GeneratedDocumentEmailAction
                                    pdfRef={pdfRef}
                                    funeral={funeral}
                                    user={user}
                                />
                            </Toolbar>
                        </Grid>
                    </Grid>

                    <Divider/>
                    <Grid className={classes.marginTop}
                          container
                          spacing={0}
                          direction="column"
                          alignItems="center"
                          justifyContent="center"
                    >
                        {showDelegation()}
                    </Grid>
                </Paper>
            </div>
            {success ? <Redirect to={{
                pathname: `/pohreb/${funeral_id.funeral_id}/info`,
                state: {from: props.location, number: 5}
            }}/> : <></>}
        </Container>
    )
}
export default InformationPaperGenerator;

